import React from 'react';

export default function Card({ children }) {
  return (
    <div className="border rounded-lg shadow-md bg-white">
      {children}
    </div>
  );
}